import { lazy } from 'react'

export const DietTypeV1 = lazy(() => import('./v1/DietTypeV1'))
